module.exports = __webpack_public_path__ + "static/media/radiator box.2537a701.jpg";